import type { SupportingMethod, SupportingAnalysis, SupportingMethodContext } from './types.js';
import { adxDmi } from './methods/adx.js';
import { bollingerSqueeze } from './methods/bollinger.js';
import { donchianBreakout } from './methods/donchian.js';
import { obvDivergence } from './methods/obv.js';
import { rsiDivergence } from './methods/rsiDivergence.js';
import { sessionVwap } from './methods/vwap.js';
import { supertrend } from './methods/supertrend.js';

export const SUPPORTING_METHODS: readonly SupportingMethod[] = [
  rsiDivergence,
  obvDivergence,
  sessionVwap,
  adxDmi,
  bollingerSqueeze,
  donchianBreakout,
  supertrend,
];

export function evaluateSupportingMethods(
  context: SupportingMethodContext,
  sourceInterval: string,
): SupportingAnalysis {
  const methods = SUPPORTING_METHODS.map((method) => method(context));
  const score = methods.reduce((sum, method) => sum + method.contribution, 0);
  const supportiveCount = methods.filter((method) => method.rawSignal === 1 && method.dataSufficient).length;
  return {
    score,
    methods,
    evaluatedAt: context.now,
    sourceInterval,
    status: 'experimental',
    supportiveCount,
  };
}
